import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { registerLocaleData } from '@angular/common';
import germanLocale from '@angular/common/locales/de';
import armenianLocale from '@angular/common/locales/hy';
import frenchLocale from '@angular/common/locales/fr'
import russianLocale from '@angular/common/locales/ru'
import spanishLocale from '@angular/common/locales/es'


registerLocaleData(germanLocale);
registerLocaleData(armenianLocale);
registerLocaleData(frenchLocale);
registerLocaleData(russianLocale);
registerLocaleData(spanishLocale);

@Pipe({
    name: 'dateLocal',
    pure: false
})
export class DateLocalPipe implements PipeTransform {
    constructor(private translateService: TranslateService) { }

    transform(value: Date | string, format = 'hh:mm - EEE, MMM d'): string {
        const datePipe = new DatePipe(this.translateService.currentLang || 'en');
        return datePipe.transform(value, format);
    }

}